import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * Create folder dialog — text input for folder name.
 *
 * Renders as a slide-over drawer. Auto-focuses the input,
 * supports Enter to confirm and Escape to cancel.
 */
import { useCallback, useEffect, useRef, useState } from 'react';
import { SlideDrawer } from './SlideDrawer';
export function CreateFolderDialog({ open, parentPath, creating, error, onConfirm, onCancel, }) {
    const [name, setName] = useState('');
    const inputRef = useRef(null);
    useEffect(() => {
        if (open) {
            setName('');
            requestAnimationFrame(() => {
                inputRef.current?.focus();
            });
        }
    }, [open]);
    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        const trimmed = name.trim();
        if (trimmed && !creating) {
            onConfirm(trimmed);
        }
    }, [name, creating, onConfirm]);
    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const trimmed = name.trim();
            if (trimmed && !creating) {
                onConfirm(trimmed);
            }
        }
    }, [name, creating, onConfirm]);
    const parentDisplay = parentPath.length > 0
        ? parentPath.join(' / ')
        : 'root';
    const canSubmit = name.trim().length > 0 && !creating;
    return (_jsx(SlideDrawer, { open: open, title: "New Folder", onClose: creating ? () => { } : onCancel, footer: _jsxs(_Fragment, { children: [_jsx("button", { type: "button", className: "ac-btn ac-btn-sm", onClick: onCancel, disabled: creating, children: "Cancel" }), _jsx("button", { type: "button", className: "ac-btn ac-btn-sm ac-btn-primary", onClick: () => { const t = name.trim(); if (t && !creating)
                        onConfirm(t); }, disabled: !canSubmit, children: creating ? 'Creating...' : 'Create' })] }), children: _jsxs("form", { onSubmit: handleSubmit, children: [_jsxs("p", { style: { margin: '0 0 0.75rem', color: 'var(--ac-text-secondary)' }, children: ["Create folder in ", _jsx("strong", { children: parentDisplay })] }), _jsx("input", { ref: inputRef, type: "text", className: "ac-input", placeholder: "Folder name", value: name, onChange: (e) => setName(e.target.value), onKeyDown: handleKeyDown, disabled: creating, autoComplete: "off", style: { width: '100%' } }), error && (_jsx("div", { className: "ac-operation-error", style: { marginTop: '0.75rem' }, children: error }))] }) }));
}
//# sourceMappingURL=CreateFolderDialog.js.map